import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';
const BUSINESS_NAME = 'Carros de la Cruz';
const BUSINESS_EMAIL = 'info@faranduladelacruz.com';
const BUSINESS_PHONE = '(857) 271-5381';
const BUSINESS_ADDRESS = '21400 NW 2nd Ave, Miami Gardens, FL 33169';
const PrivacyPolicy = () => {
  return <LegalLayout title="Política de Privacidad / Privacy Policy" updated="Última actualización / Last updated: 16 de agosto, 2026" data-id="element-474" data-mp="mat0f9rgje5w">
      <LegalSection heading="1. Quiénes somos / Who we are" data-id="element-475" data-mp="1e0noz47hqzti">
        <p data-id="element-476" data-mp="1e1798rkm60ap">
          {BUSINESS_NAME} ("nosotros", "nuestro"). Dirección:{' '}
          {BUSINESS_ADDRESS}. Teléfono: {BUSINESS_PHONE}. Correo:{' '}
          <a href={`mailto:${BUSINESS_EMAIL}`} className="text-primary underline" data-id="element-477" data-mp="158lvjpvuajsq">
            {BUSINESS_EMAIL}
          </a>
          .
        </p>
        <p data-id="element-478" data-mp="1wzjlim6tnqai">
          {BUSINESS_NAME} ("we", "us", "our") operates faranduladelacruz.com and
          is responsible for the personal information collected through this
          website.
        </p>
      </LegalSection>

      <LegalSection heading="2. Información que recopilamos / Information we collect" data-id="element-479" data-mp="a0nfr7fmj46u">
        <p data-id="element-480" data-mp="3rgviqoyno0sz">
          Cuando llenas nuestro formulario de solicitud recopilamos: nombre,
          número de teléfono, correo electrónico, vehículo de interés y rango
          aproximado de crédito. También recopilamos datos técnicos de uso
          (páginas vistas, tiempo en el sitio, origen del tráfico) mediante
          cookies y píxeles de terceros.
        </p>
        <p data-id="element-481" data-mp="3ncxoark9ze69">
          When you submit our request form we collect: name, phone number, email
          address, vehicle of interest, and approximate credit range. We also
          collect technical usage data (pages viewed, time on site, traffic
          source) through cookies and third-party pixels.
        </p>
      </LegalSection>

      <LegalSection heading="3. Cómo usamos tu información / How we use your information" data-id="element-482" data-mp="1bpzlafgd0q5q">
        <ul className="list-disc pl-5 space-y-2" data-id="element-483" data-mp="1a8twi8qszf9v">
          <li data-id="element-484" data-mp="1a9lshkobbf0o">
            Contactarte por teléfono, SMS, WhatsApp o correo sobre tu solicitud
            de vehículo. / To contact you by phone, SMS, WhatsApp, or email
            regarding your vehicle request.
          </li>
          <li data-id="element-485" data-mp="w8j5n5phu0op">
            Pre-calificarte para opciones de financiamiento. / To pre-qualify
            you for financing options.
          </li>
          <li data-id="element-486" data-mp="1sxh0enx8tylv">
            Enviarte ofertas y actualizaciones si diste consentimiento. / To
            send you offers and updates if you opted in.
          </li>
          <li data-id="element-487" data-mp="1j8qrst7p7cdw">
            Medir el rendimiento de nuestra publicidad. / To measure the
            performance of our advertising.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="4. Mensajes SMS y WhatsApp / SMS and WhatsApp messaging" data-id="element-488" data-mp="1f5kl5kgobj6w">
        <p data-id="element-489" data-mp="2bre87vbr238n">
          Al enviar el formulario y marcar la casilla de consentimiento, aceptas
          recibir mensajes SMS de {BUSINESS_NAME} relacionados con tu solicitud
          y ofertas. La frecuencia de mensajes varía. Pueden aplicar tarifas de
          mensajes y datos. Responde <strong data-id="element-490" data-mp="3ukxrvpkzlzxx">STOP</strong> para cancelar la
          suscripción y <strong data-id="element-491" data-mp="2gc3lqmxq66i">HELP</strong> para obtener ayuda.
        </p>
        <p data-id="element-492" data-mp="2iy97kq9mbm3">
          By submitting the form and checking the consent box, you agree to
          receive SMS messages from {BUSINESS_NAME} related to your request and
          promotional offers. Message frequency varies. Message and data rates
          may apply. Reply <strong data-id="element-493" data-mp="hcb9cumknu8h">STOP</strong> to unsubscribe and{' '}
          <strong data-id="element-494" data-mp="m4uovx4tkzfx">HELP</strong> for help.
        </p>
        <p className="font-semibold text-primary" data-id="element-495" data-mp="m54bdaqnoogv">
          No compartimos ni vendemos información de consentimiento SMS ni datos
          de suscriptores con terceros para fines de marketing. / We do not
          share or sell SMS consent information or subscriber data with third
          parties for marketing purposes.
        </p>
      </LegalSection>

      <LegalSection heading="5. Con quién compartimos / Who we share with" data-id="element-496" data-mp="mgv9ljla2fak">
        <p data-id="element-497" data-mp="hik2vhqa4kwk">
          Compartimos datos únicamente con proveedores de servicio necesarios
          para operar: nuestro CRM y plataforma de mensajería, hojas de cálculo
          internas, y plataformas de publicidad para medición. Estos proveedores
          están obligados a proteger tu información y no pueden usarla para sus
          propios fines de marketing.
        </p>
        <p data-id="element-498" data-mp="3klzf7dhy8vu">
          We share data only with service providers necessary to operate: our
          CRM and messaging platform, internal spreadsheets, and advertising
          platforms for measurement. These providers are required to protect
          your information and may not use it for their own marketing purposes.
        </p>
      </LegalSection>

      <LegalSection heading="6. Cookies y píxeles / Cookies and pixels" data-id="element-499" data-mp="1ov2gutp1den7">
        <p data-id="element-500" data-mp="1jxk7x3b0qzf7">
          Usamos el Meta Pixel para medir conversiones de nuestros anuncios.
          Puedes desactivar las cookies desde la configuración de tu navegador.
        </p>
        <p data-id="element-501" data-mp="1wfmyayy0t796">
          We use the Meta Pixel to measure conversions from our ads. You can
          disable cookies through your browser settings.
        </p>
      </LegalSection>

      <LegalSection heading="7. Tus derechos / Your rights" data-id="element-502" data-mp="1ihydts7v824n">
        <p data-id="element-503" data-mp="1miibcwwcp7rb">
          Puedes solicitar acceso, corrección o eliminación de tus datos en
          cualquier momento escribiendo a{' '}
          <a href={`mailto:${BUSINESS_EMAIL}`} className="text-primary underline" data-id="element-504" data-mp="2a94fid38i7w1">
            {BUSINESS_EMAIL}
          </a>
          . Responderemos dentro de 30 días.
        </p>
        <p data-id="element-505" data-mp="25gbcbtnez7m2">
          You may request access, correction, or deletion of your data at any
          time by emailing {BUSINESS_EMAIL}. We will respond within 30 days.
        </p>
      </LegalSection>

      <LegalSection heading="8. Menores de edad / Minors" data-id="element-506" data-mp="2xwm27u7n6fs5">
        <p data-id="element-507" data-mp="2xy6tnayntils">
          Este sitio no está dirigido a menores de 18 años y no recopilamos
          intencionalmente su información. / This site is not directed to
          individuals under 18 and we do not knowingly collect their
          information.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contacto / Contact" data-id="element-508" data-mp="2yqmoxc8625qn">
        <p data-id="element-509" data-mp="2tsthkfv4n5os">
          {BUSINESS_NAME}
          <br data-id="element-510" data-mp="2trrzhrfp1ixk" />
          {BUSINESS_ADDRESS}
          <br data-id="element-511" data-mp="2tv7c8nlwafvt" />
          {BUSINESS_PHONE}
          <br data-id="element-512" data-mp="2ou08r0qsc2uy" />
          <a href={`mailto:${BUSINESS_EMAIL}`} className="text-primary underline" data-id="element-513" data-mp="2oujnk8l52b4r">
            {BUSINESS_EMAIL}
          </a>
        </p>
      </LegalSection>
    </LegalLayout>;
};
export default PrivacyPolicy;